export default __webpack_public_path__ + "static/media/Rating.d87502bc.svg";